// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModuleTitle-module__font-s-10___Fed3m {
  font-size: 10px !important;
}

.ModuleTitle-module__font-s-12___l2_up {
  font-size: 12px !important;
}

.ModuleTitle-module__font-s-13___iWDHG {
  font-size: 13px !important;
}

.ModuleTitle-module__font-s-14___cqLa9 {
  font-size: 14px !important;
}

.ModuleTitle-module__font-s-15___Z2FKN {
  font-size: 15px !important;
}

.ModuleTitle-module__font-s-16___pG8gA {
  font-size: 16px !important;
}

.ModuleTitle-module__font-s-18___smg7k {
  font-size: 18px !important;
}

.ModuleTitle-module__font-s-20___w4Vj8 {
  font-size: 20px !important;
}

.ModuleTitle-module__font-s-22___ymCDl {
  font-size: 22px !important;
}

.ModuleTitle-module__font-s-28___kczcp {
  font-size: 28px !important;
}

.ModuleTitle-module__font-w-400___vy1ns {
  font-weight: 400 !important;
}

.ModuleTitle-module__font-w-500___YL0ti {
  font-weight: 500 !important;
}

.ModuleTitle-module__font-w-600___kEvVS {
  font-weight: 600 !important;
}

.ModuleTitle-module__font-w-700___Wo5YL {
  font-weight: 700 !important;
}

.ModuleTitle-module__p-5___xyCNl {
  padding: 5px !important;
}

.ModuleTitle-module__p-12___lD4nu {
  padding: 12px !important;
}

.ModuleTitle-module__p-16___dQeU9 {
  padding: 16px !important;
}

.ModuleTitle-module__p-30___PkU6H {
  padding: 30px !important;
}

.ModuleTitle-module__p-b-0___dbETC {
  padding-bottom: 0 !important;
}

.ModuleTitle-module__p-b-5___kr27S {
  padding-bottom: 5px !important;
}

.ModuleTitle-module__p-b-10___JL2iD {
  padding-bottom: 10px !important;
}

.ModuleTitle-module__p-b-12___zuege {
  padding-bottom: 12px !important;
}

.ModuleTitle-module__p-b-16___GqzTI {
  padding-bottom: 16px !important;
}

.ModuleTitle-module__p-b-18___UBW3b {
  padding-bottom: 18px !important;
}

.ModuleTitle-module__p-b-20___yXeWL {
  padding-bottom: 20px !important;
}

.ModuleTitle-module__p-b-25___XkkrL {
  padding-bottom: 25px !important;
}

.ModuleTitle-module__p-b-30___LRlNX {
  padding-bottom: 30px !important;
}

.ModuleTitle-module__p-b-50___AMq14 {
  padding-bottom: 50px !important;
}

.ModuleTitle-module__p-t-0___dfvqo {
  padding-top: 0 !important;
}

.ModuleTitle-module__p-t-12___QxtA8 {
  padding-top: 12px !important;
}

.ModuleTitle-module__p-t-16___PShil {
  padding-top: 16px !important;
}

.ModuleTitle-module__p-t-18___Rrtwd {
  padding-top: 18px !important;
}

.ModuleTitle-module__p-t-20___F8r_3 {
  padding-top: 20px !important;
}

.ModuleTitle-module__p-t-30___aSDuY {
  padding-top: 30px !important;
}

.ModuleTitle-module__p-t-40___jY2gm {
  padding-top: 40px !important;
}

.ModuleTitle-module__p-t-50___jariq {
  padding-top: 50px !important;
}

.ModuleTitle-module__p-l-20___KoM03 {
  padding-left: 20px !important;
}

.ModuleTitle-module__p-l-30___FczBf {
  padding-left: 30px !important;
}

.ModuleTitle-module__p-l-40___hEYeF {
  padding-left: 40px !important;
}

.ModuleTitle-module__p-r-16___xF6tF {
  padding-right: 16px !important;
}

.ModuleTitle-module__p-r-20___w9eu3 {
  padding-right: 20px !important;
}

.ModuleTitle-module__p-r-30___j4JBd {
  padding-right: 30px !important;
}

.ModuleTitle-module__p-r-50___MnQBR {
  padding-right: 50px !important;
}

.ModuleTitle-module__p-r-60___YLJl6 {
  padding-right: 60px !important;
}

.ModuleTitle-module__m-b-1___fijjc {
  margin-bottom: 1px !important;
}

.ModuleTitle-module__m-b-2___quHMp {
  margin-bottom: 2px !important;
}

.ModuleTitle-module__m-b-6___bR0GR {
  margin-bottom: 6px !important;
}

.ModuleTitle-module__m-b-8___pk6UG {
  margin-bottom: 8px !important;
}

.ModuleTitle-module__m-b-10___IapwS {
  margin-bottom: 10px !important;
}

.ModuleTitle-module__m-b-14___XiZav {
  margin-bottom: 14px !important;
}

.ModuleTitle-module__m-b-16___zn6im {
  margin-bottom: 16px !important;
}

.ModuleTitle-module__m-b-20___vuMdb {
  margin-bottom: 20px !important;
}

.ModuleTitle-module__m-b-22___SNwZs {
  margin-bottom: 22px !important;
}

.ModuleTitle-module__m-b-24___EBINj {
  margin-bottom: 24px !important;
}

.ModuleTitle-module__m-b-30___PKXba {
  margin-bottom: 30px !important;
}

.ModuleTitle-module__m-b-32___cgZlo {
  margin-bottom: 32px !important;
}

.ModuleTitle-module__m-b-40___eRMiO {
  margin-bottom: 40px !important;
}

.ModuleTitle-module__m-t-2___vC3vD {
  margin-top: 2px !important;
}

.ModuleTitle-module__m-t-3___lHtwz {
  margin-top: 3px !important;
}

.ModuleTitle-module__m-t-4___ahsNd {
  margin-top: 4px !important;
}

.ModuleTitle-module__m-t-5___wKAz6 {
  margin-top: 5px !important;
}

.ModuleTitle-module__m-t-8___IbTIK {
  margin-top: 8px !important;
}

.ModuleTitle-module__m-t-10___S6vj0 {
  margin-top: 10px !important;
}

.ModuleTitle-module__m-t-15___dE_c6 {
  margin-top: 15px !important;
}

.ModuleTitle-module__m-t-16___IxU2F {
  margin-top: 16px !important;
}

.ModuleTitle-module__m-t-20___mjHQ9 {
  margin-top: 20px !important;
}

.ModuleTitle-module__m-t-22___gqeGk {
  margin-top: 22px !important;
}

.ModuleTitle-module__m-t-30___BuJoX {
  margin-top: 30px !important;
}

.ModuleTitle-module__m-t-32___mPAgj {
  margin-top: 32px !important;
}

.ModuleTitle-module__m-l-auto___k7H4_ {
  margin-left: auto !important;
}

.ModuleTitle-module__m-l-4___fAcjf {
  margin-left: 4px !important;
}

.ModuleTitle-module__m-l-5___JiRMz {
  margin-left: 5px !important;
}

.ModuleTitle-module__m-l-6___Y33rA {
  margin-left: 6px !important;
}

.ModuleTitle-module__m-l-8___OG_Fo {
  margin-left: 8px !important;
}

.ModuleTitle-module__m-l-10___mfws2 {
  margin-left: 10px !important;
}

.ModuleTitle-module__m-l-16___DcGYA {
  margin-left: 16px !important;
}

.ModuleTitle-module__m-l-20___FC0gR {
  margin-left: 20px !important;
}

.ModuleTitle-module__m-l-24___EMEwo {
  margin-left: 24px !important;
}

.ModuleTitle-module__m-l-30___eXaGC {
  margin-left: 30px !important;
}

.ModuleTitle-module__m-l-35___CN3q8 {
  margin-left: 35px !important;
}

.ModuleTitle-module__m-l-40___zKIUp {
  margin-left: 40px !important;
}

.ModuleTitle-module__m-r-8___HfJfW {
  margin-right: 8px !important;
}

.ModuleTitle-module__m-r-10___FUPuD {
  margin-right: 10px !important;
}

.ModuleTitle-module__m-r-16___WGmO2 {
  margin-right: 16px !important;
}

.ModuleTitle-module__m-r-20___MMv1d {
  margin-right: 20px !important;
}

.ModuleTitle-module__m-r-24___N6OW8 {
  margin-right: 24px !important;
}

.ModuleTitle-module__m-r-30___ilV6P {
  margin-right: 30px !important;
}

.ModuleTitle-module__m-r-40___Fh0vg {
  margin-right: 40px !important;
}

.ModuleTitle-module__border-r-3___rJ20p {
  border-radius: 3px !important;
}

.ModuleTitle-module__border-r-4___AqkW6 {
  border-radius: 4px !important;
}

.ModuleTitle-module__border-r-6___Tq4NX {
  border-radius: 6px !important;
}

.ModuleTitle-module__border-r-10___ggsWm {
  border-radius: 10px !important;
}

.ModuleTitle-module__border-r-12___eUM7B {
  border-radius: 12px !important;
}

.ModuleTitle-module__border-r-16___uRwJ8 {
  border-radius: 16px !important;
}

.ModuleTitle-module__border-r-50___KLwcX {
  border-radius: 50% !important;
}

.ModuleTitle-module__primary-border___qnzP0 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ModuleTitle-module__primary-border-b___TJatP {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ModuleTitle-module__primary-border-t___BAIlV {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ModuleTitle-module__primary-border-l___s_o5M {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ModuleTitle-module__primary-border-r___o_iP6 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ModuleTitle-module__secondary-border___kiTqd {
  border: 1px solid #637768;
}

.ModuleTitle-module__secondary-border-b___e0KRo {
  border-bottom: 1px solid #637768;
}

.ModuleTitle-module__secondary-border-t___JTL7x {
  border-top: 1px solid #637768;
}

.ModuleTitle-module__secondary-border-l___AZOM1 {
  border-left: 1px solid #637768;
}

.ModuleTitle-module__secondary-border-r___eOG0m {
  border-right: 1px solid #637768;
}

.ModuleTitle-module__gap-0___HI7E7 {
  gap: 0 !important;
}

.ModuleTitle-module__gap-2___tvtRM {
  gap: 2px !important;
}

.ModuleTitle-module__gap-4___PYmG6 {
  gap: 4px !important;
}

.ModuleTitle-module__gap-5___h9_2v {
  gap: 5px !important;
}

.ModuleTitle-module__gap-6___tvr1J {
  gap: 6px !important;
}

.ModuleTitle-module__gap-8___VImUH {
  gap: 8px !important;
}

.ModuleTitle-module__gap-10___S_uyl {
  gap: 10px !important;
}

.ModuleTitle-module__gap-12___NRTLc {
  gap: 12px !important;
}

.ModuleTitle-module__gap-14___zDCD3 {
  gap: 14px !important;
}

.ModuleTitle-module__gap-16___QxcuV {
  gap: 16px !important;
}

.ModuleTitle-module__gap-18___Z_Wtr {
  gap: 18px !important;
}

.ModuleTitle-module__gap-20___HjaTc {
  gap: 20px !important;
}

.ModuleTitle-module__gap-24___KJP8H {
  gap: 24px !important;
}

.ModuleTitle-module__gap-26___jaxbG {
  gap: 26px !important;
}

.ModuleTitle-module__gap-30___gglZJ {
  gap: 30px !important;
}

.ModuleTitle-module__gap-32___geREh {
  gap: 32px !important;
}

.ModuleTitle-module__gap-40___hiDK6 {
  gap: 40px !important;
}

.ModuleTitle-module__gap-50___t5nPw {
  gap: 50px !important;
}

.ModuleTitle-module__flex-1___L4DAJ {
  flex: 1;
}

.ModuleTitle-module__flex-none___pTrDj {
  flex: none !important;
}

.ModuleTitle-module__flex-column___rMr90 {
  display: flex;
  flex-direction: column !important;
}

.ModuleTitle-module__flex-row___lcPJ4 {
  display: flex;
  flex-direction: row !important;
}

.ModuleTitle-module__vertically-centered___oXCJO {
  display: flex;
  align-items: center !important;
}

.ModuleTitle-module__horizontally-centered___XNsCk {
  display: flex;
  justify-content: center !important;
}

.ModuleTitle-module__horizontally-end___y4mi3 {
  display: flex;
  justify-content: end !important;
}

.ModuleTitle-module__vertically-start___t2Rqy {
  display: flex;
  align-items: start !important;
}

.ModuleTitle-module__space-between___NYI4M {
  display: flex;
  justify-content: space-between !important;
}

.ModuleTitle-module__flex-wrap___R3_PA {
  flex-wrap: wrap !important;
}

.ModuleTitle-module__height-100___emF6t {
  height: 100%;
}

.ModuleTitle-module__width-50___fFaum {
  width: 50% !important;
}

.ModuleTitle-module__width-100___qoH2y {
  width: 100%;
}

.ModuleTitle-module__cursor-pointer___ue8zx {
  cursor: pointer;
}

.ModuleTitle-module__cursor-not-allowed___z6jS4 {
  cursor: not-allowed !important;
}

.ModuleTitle-module__absolute-centered___vk4gf {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ModuleTitle-module__absolute___oXDRd {
  position: absolute;
}

.ModuleTitle-module__relative___LtshJ {
  position: relative;
}

.ModuleTitle-module__fixed___OYpJr {
  position: fixed;
}

.ModuleTitle-module__visible___RwG8n {
  opacity: 1;
}

.ModuleTitle-module__invisible___lYuO7 {
  opacity: 0;
}

.ModuleTitle-module__col-90___SfptN {
  width: 90% !important;
}

.ModuleTitle-module__col-auto___oxFNf {
  width: auto !important;
}

.ModuleTitle-module__medical-tabs___vhyPq {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ModuleTitle-module__medical-table-new___q5T9j {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ModuleTitle-module__medical-table-new___q5T9j:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ModuleTitle-module__medical-table-new___q5T9j::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ModuleTitle-module__medical-table-new___q5T9j::-webkit-scrollbar-track {
  display: none;
}
.ModuleTitle-module__medical-table-new___q5T9j.ModuleTitle-module__no-pagination___W3ElW {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ModuleTitle-module__medical-table-new___q5T9j.ModuleTitle-module__no-pagination___W3ElW:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ModuleTitle-module__medical-table-new___q5T9j.ModuleTitle-module__no-pagination___W3ElW::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ModuleTitle-module__medical-table-new___q5T9j.ModuleTitle-module__no-pagination___W3ElW::-webkit-scrollbar-track {
  display: none;
}

.ModuleTitle-module__medical-table-empty___ZMb2d {
  padding: 14px 40px !important;
}

.ModuleTitle-module__icon-btn___Ir7LC {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ModuleTitle-module__search-icon___mGcYj {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ModuleTitle-module__disable-select___a4B7a {
  user-select: none;
}

.ModuleTitle-module__break-word___iuQiR {
  word-break: break-word;
}

.ModuleTitle-module__popup-clear-btn___EYjOP {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ModuleTitle-module__scroll-m-b-20___COJOS {
  scroll-margin-bottom: 20px;
}

.ModuleTitle-module__title___W4kv0 {
  white-space: pre;
  color: #375844;
}

.ModuleTitle-module__icon___UQlmL {
  width: 16px;
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/components/ModuleTitle/ModuleTitle.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,gBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,WAAA;EACA,YAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.title {\n  white-space: pre;\n  color: get-color(greenNew, dark);\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ModuleTitle-module__font-s-10___Fed3m`,
	"fontS12": `ModuleTitle-module__font-s-12___l2_up`,
	"fontS13": `ModuleTitle-module__font-s-13___iWDHG`,
	"fontS14": `ModuleTitle-module__font-s-14___cqLa9`,
	"fontS15": `ModuleTitle-module__font-s-15___Z2FKN`,
	"fontS16": `ModuleTitle-module__font-s-16___pG8gA`,
	"fontS18": `ModuleTitle-module__font-s-18___smg7k`,
	"fontS20": `ModuleTitle-module__font-s-20___w4Vj8`,
	"fontS22": `ModuleTitle-module__font-s-22___ymCDl`,
	"fontS28": `ModuleTitle-module__font-s-28___kczcp`,
	"fontW400": `ModuleTitle-module__font-w-400___vy1ns`,
	"fontW500": `ModuleTitle-module__font-w-500___YL0ti`,
	"fontW600": `ModuleTitle-module__font-w-600___kEvVS`,
	"fontW700": `ModuleTitle-module__font-w-700___Wo5YL`,
	"p5": `ModuleTitle-module__p-5___xyCNl`,
	"p12": `ModuleTitle-module__p-12___lD4nu`,
	"p16": `ModuleTitle-module__p-16___dQeU9`,
	"p30": `ModuleTitle-module__p-30___PkU6H`,
	"pB0": `ModuleTitle-module__p-b-0___dbETC`,
	"pB5": `ModuleTitle-module__p-b-5___kr27S`,
	"pB10": `ModuleTitle-module__p-b-10___JL2iD`,
	"pB12": `ModuleTitle-module__p-b-12___zuege`,
	"pB16": `ModuleTitle-module__p-b-16___GqzTI`,
	"pB18": `ModuleTitle-module__p-b-18___UBW3b`,
	"pB20": `ModuleTitle-module__p-b-20___yXeWL`,
	"pB25": `ModuleTitle-module__p-b-25___XkkrL`,
	"pB30": `ModuleTitle-module__p-b-30___LRlNX`,
	"pB50": `ModuleTitle-module__p-b-50___AMq14`,
	"pT0": `ModuleTitle-module__p-t-0___dfvqo`,
	"pT12": `ModuleTitle-module__p-t-12___QxtA8`,
	"pT16": `ModuleTitle-module__p-t-16___PShil`,
	"pT18": `ModuleTitle-module__p-t-18___Rrtwd`,
	"pT20": `ModuleTitle-module__p-t-20___F8r_3`,
	"pT30": `ModuleTitle-module__p-t-30___aSDuY`,
	"pT40": `ModuleTitle-module__p-t-40___jY2gm`,
	"pT50": `ModuleTitle-module__p-t-50___jariq`,
	"pL20": `ModuleTitle-module__p-l-20___KoM03`,
	"pL30": `ModuleTitle-module__p-l-30___FczBf`,
	"pL40": `ModuleTitle-module__p-l-40___hEYeF`,
	"pR16": `ModuleTitle-module__p-r-16___xF6tF`,
	"pR20": `ModuleTitle-module__p-r-20___w9eu3`,
	"pR30": `ModuleTitle-module__p-r-30___j4JBd`,
	"pR50": `ModuleTitle-module__p-r-50___MnQBR`,
	"pR60": `ModuleTitle-module__p-r-60___YLJl6`,
	"mB1": `ModuleTitle-module__m-b-1___fijjc`,
	"mB2": `ModuleTitle-module__m-b-2___quHMp`,
	"mB6": `ModuleTitle-module__m-b-6___bR0GR`,
	"mB8": `ModuleTitle-module__m-b-8___pk6UG`,
	"mB10": `ModuleTitle-module__m-b-10___IapwS`,
	"mB14": `ModuleTitle-module__m-b-14___XiZav`,
	"mB16": `ModuleTitle-module__m-b-16___zn6im`,
	"mB20": `ModuleTitle-module__m-b-20___vuMdb`,
	"mB22": `ModuleTitle-module__m-b-22___SNwZs`,
	"mB24": `ModuleTitle-module__m-b-24___EBINj`,
	"mB30": `ModuleTitle-module__m-b-30___PKXba`,
	"mB32": `ModuleTitle-module__m-b-32___cgZlo`,
	"mB40": `ModuleTitle-module__m-b-40___eRMiO`,
	"mT2": `ModuleTitle-module__m-t-2___vC3vD`,
	"mT3": `ModuleTitle-module__m-t-3___lHtwz`,
	"mT4": `ModuleTitle-module__m-t-4___ahsNd`,
	"mT5": `ModuleTitle-module__m-t-5___wKAz6`,
	"mT8": `ModuleTitle-module__m-t-8___IbTIK`,
	"mT10": `ModuleTitle-module__m-t-10___S6vj0`,
	"mT15": `ModuleTitle-module__m-t-15___dE_c6`,
	"mT16": `ModuleTitle-module__m-t-16___IxU2F`,
	"mT20": `ModuleTitle-module__m-t-20___mjHQ9`,
	"mT22": `ModuleTitle-module__m-t-22___gqeGk`,
	"mT30": `ModuleTitle-module__m-t-30___BuJoX`,
	"mT32": `ModuleTitle-module__m-t-32___mPAgj`,
	"mLAuto": `ModuleTitle-module__m-l-auto___k7H4_`,
	"mL4": `ModuleTitle-module__m-l-4___fAcjf`,
	"mL5": `ModuleTitle-module__m-l-5___JiRMz`,
	"mL6": `ModuleTitle-module__m-l-6___Y33rA`,
	"mL8": `ModuleTitle-module__m-l-8___OG_Fo`,
	"mL10": `ModuleTitle-module__m-l-10___mfws2`,
	"mL16": `ModuleTitle-module__m-l-16___DcGYA`,
	"mL20": `ModuleTitle-module__m-l-20___FC0gR`,
	"mL24": `ModuleTitle-module__m-l-24___EMEwo`,
	"mL30": `ModuleTitle-module__m-l-30___eXaGC`,
	"mL35": `ModuleTitle-module__m-l-35___CN3q8`,
	"mL40": `ModuleTitle-module__m-l-40___zKIUp`,
	"mR8": `ModuleTitle-module__m-r-8___HfJfW`,
	"mR10": `ModuleTitle-module__m-r-10___FUPuD`,
	"mR16": `ModuleTitle-module__m-r-16___WGmO2`,
	"mR20": `ModuleTitle-module__m-r-20___MMv1d`,
	"mR24": `ModuleTitle-module__m-r-24___N6OW8`,
	"mR30": `ModuleTitle-module__m-r-30___ilV6P`,
	"mR40": `ModuleTitle-module__m-r-40___Fh0vg`,
	"borderR3": `ModuleTitle-module__border-r-3___rJ20p`,
	"borderR4": `ModuleTitle-module__border-r-4___AqkW6`,
	"borderR6": `ModuleTitle-module__border-r-6___Tq4NX`,
	"borderR10": `ModuleTitle-module__border-r-10___ggsWm`,
	"borderR12": `ModuleTitle-module__border-r-12___eUM7B`,
	"borderR16": `ModuleTitle-module__border-r-16___uRwJ8`,
	"borderR50": `ModuleTitle-module__border-r-50___KLwcX`,
	"primaryBorder": `ModuleTitle-module__primary-border___qnzP0`,
	"primaryBorderB": `ModuleTitle-module__primary-border-b___TJatP`,
	"primaryBorderT": `ModuleTitle-module__primary-border-t___BAIlV`,
	"primaryBorderL": `ModuleTitle-module__primary-border-l___s_o5M`,
	"primaryBorderR": `ModuleTitle-module__primary-border-r___o_iP6`,
	"secondaryBorder": `ModuleTitle-module__secondary-border___kiTqd`,
	"secondaryBorderB": `ModuleTitle-module__secondary-border-b___e0KRo`,
	"secondaryBorderT": `ModuleTitle-module__secondary-border-t___JTL7x`,
	"secondaryBorderL": `ModuleTitle-module__secondary-border-l___AZOM1`,
	"secondaryBorderR": `ModuleTitle-module__secondary-border-r___eOG0m`,
	"gap0": `ModuleTitle-module__gap-0___HI7E7`,
	"gap2": `ModuleTitle-module__gap-2___tvtRM`,
	"gap4": `ModuleTitle-module__gap-4___PYmG6`,
	"gap5": `ModuleTitle-module__gap-5___h9_2v`,
	"gap6": `ModuleTitle-module__gap-6___tvr1J`,
	"gap8": `ModuleTitle-module__gap-8___VImUH`,
	"gap10": `ModuleTitle-module__gap-10___S_uyl`,
	"gap12": `ModuleTitle-module__gap-12___NRTLc`,
	"gap14": `ModuleTitle-module__gap-14___zDCD3`,
	"gap16": `ModuleTitle-module__gap-16___QxcuV`,
	"gap18": `ModuleTitle-module__gap-18___Z_Wtr`,
	"gap20": `ModuleTitle-module__gap-20___HjaTc`,
	"gap24": `ModuleTitle-module__gap-24___KJP8H`,
	"gap26": `ModuleTitle-module__gap-26___jaxbG`,
	"gap30": `ModuleTitle-module__gap-30___gglZJ`,
	"gap32": `ModuleTitle-module__gap-32___geREh`,
	"gap40": `ModuleTitle-module__gap-40___hiDK6`,
	"gap50": `ModuleTitle-module__gap-50___t5nPw`,
	"flex1": `ModuleTitle-module__flex-1___L4DAJ`,
	"flexNone": `ModuleTitle-module__flex-none___pTrDj`,
	"flexColumn": `ModuleTitle-module__flex-column___rMr90`,
	"flexRow": `ModuleTitle-module__flex-row___lcPJ4`,
	"verticallyCentered": `ModuleTitle-module__vertically-centered___oXCJO`,
	"horizontallyCentered": `ModuleTitle-module__horizontally-centered___XNsCk`,
	"horizontallyEnd": `ModuleTitle-module__horizontally-end___y4mi3`,
	"verticallyStart": `ModuleTitle-module__vertically-start___t2Rqy`,
	"spaceBetween": `ModuleTitle-module__space-between___NYI4M`,
	"flexWrap": `ModuleTitle-module__flex-wrap___R3_PA`,
	"height100": `ModuleTitle-module__height-100___emF6t`,
	"width50": `ModuleTitle-module__width-50___fFaum`,
	"width100": `ModuleTitle-module__width-100___qoH2y`,
	"cursorPointer": `ModuleTitle-module__cursor-pointer___ue8zx`,
	"cursorNotAllowed": `ModuleTitle-module__cursor-not-allowed___z6jS4`,
	"absoluteCentered": `ModuleTitle-module__absolute-centered___vk4gf`,
	"absolute": `ModuleTitle-module__absolute___oXDRd`,
	"relative": `ModuleTitle-module__relative___LtshJ`,
	"fixed": `ModuleTitle-module__fixed___OYpJr`,
	"visible": `ModuleTitle-module__visible___RwG8n`,
	"invisible": `ModuleTitle-module__invisible___lYuO7`,
	"col90": `ModuleTitle-module__col-90___SfptN`,
	"colAuto": `ModuleTitle-module__col-auto___oxFNf`,
	"medicalTabs": `ModuleTitle-module__medical-tabs___vhyPq`,
	"medicalTableNew": `ModuleTitle-module__medical-table-new___q5T9j`,
	"noPagination": `ModuleTitle-module__no-pagination___W3ElW`,
	"medicalTableEmpty": `ModuleTitle-module__medical-table-empty___ZMb2d`,
	"iconBtn": `ModuleTitle-module__icon-btn___Ir7LC`,
	"searchIcon": `ModuleTitle-module__search-icon___mGcYj`,
	"disableSelect": `ModuleTitle-module__disable-select___a4B7a`,
	"breakWord": `ModuleTitle-module__break-word___iuQiR`,
	"popupClearBtn": `ModuleTitle-module__popup-clear-btn___EYjOP`,
	"scrollMB20": `ModuleTitle-module__scroll-m-b-20___COJOS`,
	"title": `ModuleTitle-module__title___W4kv0`,
	"icon": `ModuleTitle-module__icon___UQlmL`
};
module.exports = ___CSS_LOADER_EXPORT___;
